import React from "react";
import PropTypes from "prop-types";

const Navbar = (props) => {
  const { current_step, progress_text } = props;

  return (
    <React.Fragment>
      <div className='row d-flex justify-content-center'>
        <div className='col-12 col-lg-10'>
          <nav className='navbar navbar-menu' role='navigation' id='steps'>
            <div className='navbar-collapse'>
              <ul className='nav navbar-nav navbar-main flex-row'>
                <li className={`navbar-item col-4 align-middle ${"step1" === current_step ? "active" : ""}`}>
                  <span className='step-name'>
                    <span className='icon-arrow-right'>
                      必須情報
                    </span>
                  </span>
                </li>
                <li className={`navbar-item col-4 align-middle ${"step2" === current_step ? "active" : ""}`}>
                  <span className='step-name'>
                    <span className='icon-arrow-right'>
                      所属
                    </span>
                  </span>
                </li>
                <li className={`navbar-item col-4 align-middle ${"step3" === current_step ? "active" : ""}`}>
                  <span className='step-name'>
                    <span className='icon-arrow-right'>
                      自己紹介
                    </span>
                  </span>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
      <div className='row d-flex justify-content-center'>
        <div className='col-12 col-lg-10 text-center progress-explain'>
          <span>{progress_text}</span>
        </div>
      </div>
    </React.Fragment>
  );
};

Navbar.propTypes = {
  current_step: PropTypes.string.isRequired,
  progress_text: PropTypes.string.isRequired
};

export default Navbar;
